import moment from 'moment';

export const columns = [
  {
    field: 'id',
    headerName: 'ID',
    type: 'number',
    hide: true,
    hideable: false,
    filterable: false,
    getApplyQuickFilterFn: undefined,
  },
  {
    field: 'name',
    headerName: 'Imię',
    minWidth: 150,
    flex: 1,
  },
  {
    field: 'surname',
    headerName: 'Nazwisko',
    minWidth: 150,
    flex: 1,
  },
  {
    field: 'email',
    headerName: 'E-mail',
    minWidth: 250,
    flex: 1,
  },
  {
    field: 'department',
    headerName: 'Oddział',
    minWidth: 150,
    flex: 1,
  },
  {
    field: 'registrationDate',
    headerName: 'Data rejestracji',
    renderCell: (params) => {
      return moment(new Date(params.value)).format('DD-MM-YYYY');
    },
    minWidth: 150,
    flex: 1,
  },
  {
    field: 'status',
    headerName: 'Status konta',
    minWidth: 150,
    flex: 1,
    renderCell: (params) => {
      return <>{params.value === 'true' ? 'Tak' : 'Nie'}</>;
    },
  },
  {
    field: 'permissionLevel',
    headerName: 'Poziom uprawnień',
    minWidth: 150,
    flex: 1,
  },
];
